import React, { useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ArrowsRightLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid'
import {
	formatDateToYYYYMMDD,
	truncateText,
	getTourDateString,
	useAuthStatus,
} from '../../../../../utils'
import styles from './OfferItem.module.scss'
import { useNavigate } from 'react-router-dom'
const OfferItem = ({
	item,
	tabType, // 'received' | 'sent' | 'past'
	// auth,
	likedContractIds,
	onLikeClick,
	onHistoryClick,
	onVisitRenew,
	onContractClick,
}) => {
	const [auth] = useAuthStatus()
	const navigate = useNavigate()
	const isReceived = tabType === 'received'
	const isSent = tabType === 'sent'
	const isPast = tabType === 'past'

	// tabType에 따라 표시할 사용자 결정
	const displayUser = useMemo(() => {
		if (isPast) {
			// past 탭에서는 target_user_id에 따라 결정
			return item.target_user_id === auth.user.id ? item.user : item.targetUser
		}
		if (isSent) {
			return item.targetUser
		}
		// received 탭
		if (item.offer_status === 'CONTRACT_PROPOSED') {
			return item.targetUser
		}
		return item.user
	}, [item])

	const mapCareerLevelToText = {
		NEWBIE: '신입',
		ONE_TO_THREE: '1~3년차',
		FOUR_TO_SIX: '4~6년차',
		SEVEN_TO_TEN: '7~10년차',
		OVER_TEN: '10년 이상',
	}

	const displayTitle = useMemo(() => {
		const type = displayUser?.user_type === 'tourPro' ? '프로' : '캐디'

		console.log(type)
		const name = displayUser?.name
		const tour =
			displayUser?.user_type === 'tourPro'
				? displayUser.user_tour_pro?.tour_type
				: displayUser.user_tour_caddie?.tour_type
		const career =
			displayUser?.user_type === 'tourPro'
				? mapCareerLevelToText[displayUser.user_tour_pro?.career_level]
				: mapCareerLevelToText[displayUser.user_tour_caddie?.career_level]

		if (displayUser?.user_type === 'tourPro') {
			return `${tour} / ${career} / ${name}`
		} else {
			return `${type} / ${name} / ${career} / ${displayUser.user_tour_caddie?.agency_name || '프리'}`
		}
		return null
	}, [displayUser])

	// const displayUser = getDisplayUser()
	// console.log(displayUser)

	console.log(item)

	// 상태 배지 렌더링
	const renderStatusBadge = () => {
		const { offer_status, user_id } = item

		if (offer_status === 'PRE') {
			return <div className={styles.status}>대기 중</div>
		}
		if (offer_status === 'PROCEEDING') {
			return <div className={styles.status}>협상 중</div>
		}
		if (offer_status === 'REJECT') {
			return (
				<div
					className={styles.status}
					style={{ backgroundColor: '#ff6666', color: 'white' }}>
					거절한 제안
				</div>
			)
		}
		if (offer_status === 'REJECTED') {
			return (
				<div
					className={styles.status}
					style={{ backgroundColor: '#ff6666', color: 'white' }}>
					거절된 제안
				</div>
			)
		}
		if (offer_status === 'CANCEL') {
			return <div className={styles.status}>취소됨</div>
		}
		if (offer_status === 'ACCEPT') {
			return <div className={styles.status}>수락됨</div>
		}
		if (offer_status === 'CONTRACT_PROPOSED') {
			return <div className={styles.status}>계약 제안됨</div>
		}
		return null
	}

	// 계약 타입 텍스트
	const renderContractType = () => {
		const { offer_type, term_type } = item

		if (offer_type === 'short') {
			return <div>단기 계약(1개 대회)</div>
		}
		if (offer_type === 'long') {
			return <div>장기 계약({item.Offer_tour?.length || 0}개 대회)</div>
		}
		if (offer_type === 'period') {
			if (term_type === 'first_half') {
				return <div>기간계약(상반기)</div>
			}
			if (term_type === 'second_half') {
				return <div>기간계약(하반기)</div>
			}
			if (term_type === 'full_year') {
				return <div>기간계약(상반기/하반기)</div>
			}
		}
		return null
	}

	// 급여 정보 렌더링
	const renderSalaryInfo = () => {
		if (item.domesticContract !== null) {
			return (
				<React.Fragment>
					<div>
						{item.domesticContract.payrollCycles === 'weekly' ? (
							<div>주급</div>
						) : (
							<div>일시불제</div>
						)}
					</div>
					<div>
						{item.domesticContract.weeklySalaryCutThrough.toLocaleString() + ' 원'}
					</div>
				</React.Fragment>
			)
		}
		if (item.domesticContract === null && item.overseasContract !== null) {
			return (
				<React.Fragment>
					<div>
						{item.overseasContract.payrollCycles === 'weekly' ? (
							<div>주급</div>
						) : (
							<div>일시불제</div>
						)}
					</div>
					<div>
						{item.overseasContract.weeklySalaryCutThrough.toLocaleString() + ' 원'}
					</div>
				</React.Fragment>
			)
		}
		if (item.domesticContract === null && item.overseasContract === null) {
			return (
				<React.Fragment>
					<div>
						{item.termContract.payrollCycles === 'weekly' ? (
							<div>주급</div>
						) : (
							<div>일시불제</div>
						)}
					</div>
					<div>{item.termContract.salaryAmountForPeriod.toLocaleString() + ' 원'}</div>
				</React.Fragment>
			)
		}
		return null
	}

	const handleClick = (item) => {
		// console.log('item:', item.id)
		navigate(`/offers/${item.id}`)
	}

	return (
		<>
			<div className={styles.offerItem}>
				{/* Header */}
				<div className={styles.header}>
					<div className={styles.headerDetail}>
						<div style={{ position: 'relative' }}>
							{formatDateToYYYYMMDD(item.created_at)}{' '}
							{tabType === 'received' && item.is_visited === false && (
								<div className={styles.visitedIcon}></div>
							)}
						</div>

						{item.post_id == null ? (
							<div className={styles.directSuggest}>
								<div>직접 제안자</div>
								<svg
									width="11"
									height="10"
									viewBox="0 0 11 10"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M3.7155 0.899378C4.12759 0.425466 4.73572 0.125 5.41406 0.125C6.09237 0.125 6.70048 0.425436 7.11256 0.899307C7.73911 0.855532 8.38167 1.07308 8.86138 1.55279C9.34108 2.03249 9.55863 2.67504 9.51486 3.3016C9.98867 3.71368 10.2891 4.32174 10.2891 5C10.2891 5.67838 9.98856 6.28655 9.51459 6.69864C9.55827 7.32509 9.34072 7.96751 8.86109 8.44713C8.38147 8.92675 7.73906 9.14431 7.11261 9.10063C6.70052 9.57454 6.0924 9.875 5.41406 9.875C4.73576 9.875 4.12766 9.57457 3.71558 9.10071C3.08902 9.14449 2.44646 8.92694 1.96675 8.44723C1.48704 7.96752 1.26949 7.32496 1.31327 6.69841C0.839455 6.28632 0.539062 5.67826 0.539062 5C0.539062 4.32171 0.839486 3.71361 1.31334 3.30153C1.26961 2.67502 1.48717 2.03254 1.96683 1.55287C2.4465 1.0732 3.089 0.855647 3.7155 0.899378ZM7.21921 4.09296C7.33959 3.92443 7.30056 3.69023 7.13203 3.56985C6.9635 3.44947 6.72929 3.48851 6.60891 3.65704L4.99121 5.92182L4.17923 5.10984C4.03278 4.96339 3.79534 4.96339 3.6489 5.10984C3.50245 5.25628 3.50245 5.49372 3.6489 5.64016L4.7739 6.76517C4.85184 6.84311 4.96014 6.88281 5.06999 6.87372C5.17985 6.86463 5.28014 6.80766 5.34421 6.71796L7.21921 4.09296Z"
										fill="white"
									/>
								</svg>
							</div>
						) : (
							<div className={styles.suggestType}>
								<div>공고 지원자</div>
								<svg
									width="11"
									height="10"
									viewBox="0 0 11 10"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										fillRule="evenodd"
										clipRule="evenodd"
										d="M3.7155 0.899378C4.12759 0.425466 4.73572 0.125 5.41406 0.125C6.09237 0.125 6.70048 0.425436 7.11256 0.899307C7.73911 0.855532 8.38167 1.07308 8.86138 1.55279C9.34108 2.03249 9.55863 2.67504 9.51486 3.3016C9.98867 3.71368 10.2891 4.32174 10.2891 5C10.2891 5.67838 9.98856 6.28655 9.51459 6.69864C9.55827 7.32509 9.34072 7.96751 8.86109 8.44713C8.38147 8.92675 7.73906 9.14431 7.11261 9.10063C6.70052 9.57454 6.0924 9.875 5.41406 9.875C4.73576 9.875 4.12766 9.57457 3.71558 9.10071C3.08902 9.14449 2.44646 8.92694 1.96675 8.44723C1.48704 7.96752 1.26949 7.32496 1.31327 6.69841C0.839455 6.28632 0.539062 5.67826 0.539062 5C0.539062 4.32171 0.839486 3.71361 1.31334 3.30153C1.26961 2.67502 1.48717 2.03254 1.96683 1.55287C2.4465 1.0732 3.089 0.855647 3.7155 0.899378ZM7.21921 4.09296C7.33959 3.92443 7.30056 3.69023 7.13203 3.56985C6.9635 3.44947 6.72929 3.48851 6.60891 3.65704L4.99121 5.92182L4.17923 5.10984C4.03278 4.96339 3.79534 4.96339 3.6489 5.10984C3.50245 5.25628 3.50245 5.49372 3.6489 5.64016L4.7739 6.76517C4.85184 6.84311 4.96014 6.88281 5.06999 6.87372C5.17985 6.86463 5.28014 6.80766 5.34421 6.71796L7.21921 4.09296Z"
										fill="white"
									/>
								</svg>
							</div>
						)}
					</div>
					<div className={styles.headerBack}>
						{item.Offer_history?.length > 0 && (
							<div
								className={styles.historyStatus}
								// onClick={() => onHistoryClick(item.Offer_history)}
							>
								<ArrowsRightLeftIcon className={styles.historyStatusIcon} />
								{item.Offer_history?.length}
							</div>
						)}
						<div>{renderStatusBadge()}</div>
						{/* {!isPast && (
							<div onClick={() => onLikeClick(item.id)}>
								<svg
									width="16"
									height="18"
									viewBox="0 1 16 16"
									fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<path
										d="M8.71308 1.19384C8.48883 0.503094 7.51158 0.503094 7.28658 1.19384L6.14733 4.69934C6.09826 4.84983 6.00284 4.98094 5.87472 5.07389C5.74660 5.16685 5.59236 5.21689 5.43408 5.21684H1.74858C1.02258 5.21684 0.719577 6.14684 1.30758 6.57434L4.28958 8.74034C4.41767 8.83347 4.513 8.96474 4.56191 9.11537C4.61081 9.266 4.61079 9.42824 4.56183 9.57884L3.42333 13.0843C3.19833 13.7751 3.98958 14.3503 4.57683 13.9228L7.55883 11.7568C7.68699 11.6637 7.84137 11.6135 7.99983 11.6135C8.15828 11.6135 8.31266 11.6637 8.44083 11.7568L11.4228 13.9228C12.0101 14.3503 12.8013 13.7758 12.5763 13.0843L11.4378 9.57884C11.3889 9.42824 11.3888 9.266 11.4377 9.11537C11.4867 8.96474 11.582 8.83347 11.7101 8.74034L14.6921 6.57434C15.2793 6.14684 14.9778 5.21684 14.2511 5.21684H10.5648C10.4067 5.21673 10.2526 5.16662 10.1246 5.07367C9.99667 4.98073 9.90136 4.84971 9.85233 4.69934L8.71308 1.19384Z"
										stroke="#A0A0A0"
										fill={likedContractIds.has(item.id) ? '#C5995C' : 'none'}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</div>
						)} */}
					</div>
				</div>

				{/* <div className="detailed-profile-link">프로필 상세</div> */}

				{/* Body */}
				<div className={styles.content} onClick={() => handleClick(item)}>
					<div className={styles.nameCard}>
						{displayUser?.profile_image ? (
							<img
								src={displayUser.profile_image}
								alt={`${displayUser.name} 프로필`}
								className={styles.profileImage}
							/>
						) : (
							<img
								src="/images/caddie-default-profile.svg"
								alt="기본 프로필"
								className={styles.profileImage}
							/>
						)}

						<div
							style={{
								flex: 1,
								display: 'flex',
								flexDirection: 'column',
								gap: '4px',
							}}>
							<div className={styles.titleInfo}>{displayTitle}</div>
							<div className={styles.tourInfo}>
								<div
									style={{
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
									}}>
									{item.Offer_tour?.[0]?.tour?.name || '대회 미정'}
								</div>
								<div>
									{getTourDateString(
										new Date(item.Offer_tour?.[0]?.tour?.started_at),
									) || ''}
								</div>
							</div>
						</div>
					</div>
					<div style={{ marginRight: '4px' }}>
						<svg
							width="6"
							height="11"
							viewBox="0 0 6 11"
							fill="none"
							xmlns="http://www.w3.org/2000/svg">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M5.85355 5.14645C6.04882 5.34171 6.04882 5.65829 5.85355 5.85355L0.853554 10.8536C0.658292 11.0488 0.341709 11.0488 0.146447 10.8536C-0.0488153 10.6583 -0.0488153 10.3417 0.146447 10.1464L4.79289 5.5L0.146447 0.853552C-0.0488156 0.65829 -0.0488156 0.341708 0.146447 0.146446C0.341709 -0.0488167 0.658292 -0.0488167 0.853553 0.146446L5.85355 5.14645Z"
								fill="#A0A0A0"
							/>
						</svg>
					</div>
				</div>

				{/* Footer */}
				<div className={styles.contracts}>
					{renderContractType()}
					{renderSalaryInfo()}
				</div>
			</div>

			{/* Received 탭 전용 알림 배너 */}
			{isReceived &&
				auth?.user?.userType === 'tourCaddie' &&
				item.offer_status === 'CONTRACT_PROPOSED' && (
					<div className={styles.alertContractPendingContainer}>
						<span className={styles.alertContractPendingText}>
							계약 제안이 왔어요! 3일내 계약을 수락해주세요.
						</span>
						<button
							onClick={() => onContractClick(item)}
							className={styles.alertContractPendingButton}>
							상세보기
							<ChevronRightIcon className={styles.alertContractPendingButtonIcon} />
						</button>
					</div>
				)}
		</>
	)
}

export default OfferItem
